(function initIndependentSliders() {
  function jq() {
    return window.jQuery;
  }

  function canUseSlick() {
    var $ = jq();
    return !!( $ && $.fn && $.fn.slick );
  }

  function initMarqueeTextSlider() {
    if (!canUseSlick()) return false;

    var $ = jq();
    var initialized = false;

    $('.marquee_text').each(function () {
      var $el = $(this);

      if ($el.hasClass('slick-initialized')) return;
      if (!$el.children('p').length) return;

      $el.slick({
        vertical: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 13000,
        pauseOnHover: false,
        cssEase: 'linear',
        arrows: false,
        centerMode: true,
        responsive: [
          {
            breakpoint: 560,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      initialized = true;
    });

    return initialized;
  }

  function initLogoBarSlider() {
    if (!canUseSlick()) return false;

    var $ = jq();
    var initialized = false;

    $('.logo-bar-wrapper').each(function () {
      var $el = $(this);

      if ($el.hasClass('slick-initialized')) return;
      if ($el.children('.logo-bar-item').length < 2) return;

      $el.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        pauseOnHover: false,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 3,
              centerMode: true,
              centerPadding: '80px'
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 2,
              centerMode: true,
              centerPadding: '60px'
            }
          }
        ]
      });

      initialized = true;
    });

    return initialized;
  }

  function wrapMegamenuOverflow(menuClass, keepCount) {
    var menu = document.querySelector('.site-nav--is-megamenu.' + menuClass + ' .mega-menu-links .grid');
    if (!menu || menu.querySelector('.geschenke-block')) return;

    var items = Array.prototype.filter.call(menu.children, function (el) {
      return el.classList && el.classList.contains('grid__item');
    });

    if (items.length <= keepCount) return;

    var overflow = items.slice(keepCount);
    var wrapper = document.createElement('div');
    wrapper.className = 'grid__item geschenke-block';
    menu.appendChild(wrapper);
    overflow.forEach(function (node) {
      wrapper.appendChild(node);
    });
  }

  function initMegamenuLayout() {
    wrapMegamenuOverflow('GESCHENKE', 3);
    wrapMegamenuOverflow('SCHMUCK', 4);
  }

  function initAll() {
    initMegamenuLayout();
    if (!canUseSlick()) return false;
    initMarqueeTextSlider();
    initLogoBarSlider();
    return true;
  }

  function scheduleInit() {
    if (initAll()) return;

    var attempt = 0;
    var timer = setInterval(function () {
      attempt += 1;
      if (initAll() || attempt >= 30) {
        clearInterval(timer);
      }
    }, 200);
  }

  function boot() {
    scheduleInit();
  }

  if (document.readyState === 'complete') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }

  document.addEventListener('shopify:section:load', function () {
    initMarqueeTextSlider();
    initLogoBarSlider();
    initMegamenuLayout();
  });
})();

(function initMobileNavDrawer() {
  function boot() {
    if (window.__taraMobileNavInit) return;

    var drawer = document.getElementById('NavDrawer');
    if (!drawer) return;

    window.__taraMobileNavInit = true;

  function closeSubmenus() {
    drawer.querySelectorAll('.sub-menu.right').forEach(function (menu) {
      menu.classList.add('hide');
      menu.classList.remove('sub-menu-open');
      menu.style.transform = '';
      menu.style.height = '';
    });
    drawer.querySelectorAll('.main-menu-items').forEach(function (el) {
      el.classList.remove('active');
    });
    drawer.querySelectorAll('.main-menu-title').forEach(function (el) {
      el.classList.remove('active');
    });
    drawer.querySelectorAll('.main-menu-item > ul').forEach(function (el) {
      el.classList.remove('sub-menu-open');
    });
  }

  function openSubmenu(itemNumber) {
    if (!itemNumber) return;

    closeSubmenus();

    var items = drawer.querySelector('.main-menu-items');
    if (items) items.classList.add('active');
    drawer.querySelectorAll('.main-menu-title').forEach(function (el) {
      el.classList.add('active');
    });

    var target = drawer.querySelector('.sub-menu.right[data-item="' + itemNumber + '"]');
    if (!target) return;

    target.classList.remove('hide');
    target.classList.add('sub-menu-open');
    target.style.transform = 'translate(-100%)';
    target.style.height = 'auto';
  }

  var lastNavStamp = 0;

  function onNavEvent(event) {
    if (!drawer.contains(event.target)) return;

    var navTarget = event.target.closest('.sub-menu-close-icon, .main-menu-item > span.main-menu-item-arrow, .sub-menu-item > span.main-menu-item-arrow');
    if (!navTarget) return;

    var now = Date.now();
    if (now - lastNavStamp < 400) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    lastNavStamp = now;

    var closeIcon = event.target.closest('.sub-menu-close-icon');
    if (closeIcon) {
      event.preventDefault();
      event.stopPropagation();
      closeSubmenus();
      return;
    }

    var nestedArrow = event.target.closest('.sub-menu-item > span.main-menu-item-arrow');
    if (nestedArrow) {
      event.preventDefault();
      event.stopPropagation();
      var nestedItem = nestedArrow.closest('.sub-menu-item');
      if (!nestedItem) return;

      nestedItem.classList.toggle('sub-menu-dropdown-open');
      if (nestedItem.classList.contains('active')) {
        nestedItem.classList.remove('active');
        nestedItem.querySelectorAll('.megamenu__columns').forEach(function (col) {
          col.classList.remove('active');
        });
      } else {
        drawer.querySelectorAll('.sub-menu-item').forEach(function (item) {
          item.classList.remove('active');
        });
        drawer.querySelectorAll('.megamenu__columns').forEach(function (col) {
          col.classList.remove('active');
        });
        nestedItem.classList.add('active');
        nestedItem.querySelectorAll('.megamenu__columns').forEach(function (col) {
          col.classList.add('active');
        });
      }
      return;
    }

    var topArrow = event.target.closest('.main-menu-item > span.main-menu-item-arrow');
    if (topArrow) {
      event.preventDefault();
      event.stopPropagation();
      var topItem = topArrow.closest('.main-menu-item');
      if (topItem) openSubmenu(topItem.getAttribute('data-item'));
    }
  }

  drawer.querySelectorAll('.sub-menu.right').forEach(function (menu) {
    menu.classList.add('hide');
  });

  drawer.querySelectorAll('.main-menu-item-arrow, .sub-menu-close-icon').forEach(function (el) {
    el.setAttribute('role', 'button');
  });

  document.addEventListener('click', onNavEvent, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

(function initCollectionSortDropdown() {
  if (window.__taraSortFilterBound) return;
  window.__taraSortFilterBound = true;

  document.addEventListener('click', function (e) {
    var option = e.target.closest('#SortBy_custom [data-short-val]');
    if (option) {
      var sortValue = option.getAttribute('data-short-val');
      if (!sortValue) return;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortValue);
      params.delete('page');
      window.location.search = params.toString();
      return;
    }

    var label = e.target.closest('.collection_custom_filter .custom_filter_label');
    var inside = e.target.closest('.collection_custom_filter');

    document.querySelectorAll('.collection_custom_filter').forEach(function (root) {
      var list = root.querySelector('ul');
      var lbl = root.querySelector('.custom_filter_label');
      if (!list || !lbl) return;

      if (label && root.contains(label)) {
        list.classList.toggle('hide');
        lbl.classList.toggle('active');
        return;
      }

      if (!inside || !root.contains(inside)) {
        list.classList.add('hide');
        lbl.classList.remove('active');
      }
    });
  });
})();

(function initFaqTabs() {
  if (window.__taraFaqTabsBound) return;
  window.__taraFaqTabsBound = true;

  function activateTab(button) {
    if (!button) return;
    var tabId = button.getAttribute('data-tab');
    if (!tabId) return;

    var root = button.closest('.shopify-section') || document;
    root.querySelectorAll('button.faqtablinks').forEach(function (btn) {
      btn.classList.remove('active');
    });
    root.querySelectorAll('.faqtabcontent').forEach(function (panel) {
      panel.style.display = 'none';
    });

    button.classList.add('active');
    var panel = document.getElementById(tabId);
    if (panel && root.contains(panel)) panel.style.display = 'block';
  }

  function syncDefaultTabs() {
    document.querySelectorAll('.faqtab').forEach(function (tabBar) {
      var active = tabBar.querySelector('button.faqtablinks.active');
      var first = tabBar.querySelector('button.faqtablinks');
      activateTab(active || first);
    });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('button.faqtablinks');
    if (!button) return;
    e.preventDefault();
    activateTab(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncDefaultTabs);
  } else {
    syncDefaultTabs();
  }

  document.addEventListener('shopify:section:load', syncDefaultTabs);
})();
